import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=94cccbb4&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=94cccbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cccbb4",
  null
  
)

export default component.exports